export default __webpack_public_path__ + "static/media/Logo.df7e0114.jpeg";